<script>
import Title from '@components/section-title'
import { MODAL, RELOAD } from '@constants/Text'
import Vue from 'vue'
import con from '@services/connection'
import rules from '@constants/Rules'
import { GlobalBus } from '@services/bus'
import { dev, emails } from '@constants/URL'

export default {
  components: {
    Title,
  },
  props: {
    bus: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      email: '',
      rules: rules,
      loading: false,
    }
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.VALIDAR_EMAIL, this.open)
    }
    GlobalBus.$on(MODAL.VALIDAR_EMAIL, this.open)
  },
  methods: {
    open() {
      this.email = ''
      // if (this.$refs.form) {
      //   this.$refs.form.resetValidation()
      // }
      this.busModal.$emit('dialog', true)
    },
    async enviar(close) {
      // if (!this.email || !this.$refs.form.validate()) {
      //   this.$showSnack({
      //     text: 'Preencha o e-mail corretamente',
      //     button: true,
      //   })
      //   return
      // }
      // const data = {
      //   email: this.email,
      // }
      this.loading = true
      const r = await con.post(emails.validar) // , data
      if (r.status === 200) {
        this.$showSnack({
          text: r.message,
          button: true,
        })
        this.busModal.$emit('dialog', false)
        GlobalBus.$emit(RELOAD.VALIDATE_EMAIL, true)
      } else {
        this.$$showSnack({
          text: r.message,
          button: true,
        })
      }
      this.loading = false
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal">
    <Title title="Validar e-mail" />

    <div>
      <!-- <v-form ref="form" @submit.prevent>
        <v-text-field
          label="E-mail"
          @keydown.enter="enviar"
          v-model="email"
          autofocus
          :rules="[rules.required, rules.email]"
        />
      </v-form> -->
      <p>
        Você receberá um <i>link</i> para validar o seu e-mail e começar a
        utilizá-lo como remetente.
      </p>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton primary :loading="loading" @click="enviar">
        Enviar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


